import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export default function useRoofingEstimator() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useIdentifyProducts() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/roofing-estimator/identify-products`, parameters).then(parseSuccessResponseData),
        });
    }

    function useIdentifyLabor() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/roofing-estimator/identify-labor`, parameters).then(parseSuccessResponseData),
        });
    }

    return { useIdentifyProducts, useIdentifyLabor };
}
